<div class="wetter_content_container">
  <div class="bericht-text-container">
    <h3>Spezialwetter</h3>
    <p>{{spezialBericht}}</p>
  </div>
</div>
